// Column order and default widths for the Tasks grid.
//
// NOTE: BASE_COLUMNS was a useMemo keyed on activeTab whose two ternary
// branches returned the identical array. Preserved verbatim as a flat
// constant — the tab-conditional column sets land in a later commit.
export const BASE_COLUMNS = [
  // Positional row ordinal. Renumbers 1..N against whatever is currently
  // sorted/filtered on screen, so the last number in a sorted block reads
  // as a count. Structural like "checkbox"/"name" — not hideable, not
  // drag-reorderable.
  "rowNum",
  "checkbox",
  "name",
  "task",
  "group",
  "files",
  "owner",
  "status",
  "yearEnd",
  "dueDate",
  "completed",
  "nextYear",
  "docsReceived",
  "priority",
  "type",
  // tax columns conditional by activeTab
  "tax1",
  "tax2",
  "tax3",
  "tax4",
  "tax5",
  "tax6",
  "time",
  "invoiced",
  "ar",
];

// The columns actually rendered in the Tasks grid, in DOM order, per tab.
// The <colgroup> and the group-header colSpan are driven by THIS list (not
// BASE_COLUMNS), so each <col> width lines up with the header/body cell in the
// same position — <table> uses table-layout: fixed, which sizes columns
// positionally. Every key here matches the ResizeHandle columnKey on the
// corresponding header cell, so dragging a column border resizes the right one.
const COMMON_PREFIX = [
  "rowNum",
  "checkbox",
  "name",
  "priority",
  "task",
  "group",
  "files",
  "owner",
  "status",
  "fiscal_year",
  "yearEnd",
  "dueDate",
  // Date the task was finished. Server-stamped (TaskSerializer) when a task
  // becomes complete down either path, so it reads the same whether the row
  // was ticked on the detail page or dropped to "Completed" in this grid.
  "completed",
  // What became of the file the following year: rolled / waiting / won't
  // roll (TaskSerializer.next_year, rendered by NextYearCell).
  "nextYear",
];

export function renderedColumnKeys(activeTab) {
  if (activeTab === "personal") {
    // Docs Rec'd moves to the right of T1135 on the Personal tab.
    return [...COMMON_PREFIX, "type", "t1135", "docsReceived", "actions"];
  }
  if (activeTab === "corporate" || activeTab === "tslips") {
    return [
      ...COMMON_PREFIX,
      "docsReceived",
      "type",
      "t4_slips",
      "t5_slips",
      "t1135",
      "actions",
    ];
  }
  // "all" (and any other main-grid tab) has no tax columns.
  return [...COMMON_PREFIX, "docsReceived", "type", "actions"];
}

export const DEFAULT_COLUMN_WIDTHS = {
  rowNum: 44,
  checkbox: 36,
  name: 250,
  task: 100,
  group: 130,
  files: 100,
  owner: 95,
  status: 120,
  fiscal_year: 110,
  yearEnd: 80,
  dueDate: 80,
  completed: 90,
  nextYear: 120,
  docsReceived: 72,
  priority: 46,
  type: 100,
  t4_slips: 52,
  t5_slips: 52,
  t1135: 62,
  actions: 62,
  // Legacy keys still referenced by BASE_COLUMNS and the "Hide columns" menu.
  tax1: 100,
  tax2: 120,
  tax3: 120,
  tax4: 120,
  tax5: 120,
  tax6: 120,
  time: 100,
  invoiced: 100,
  ar: 100,
};
